module.exports = __webpack_public_path__ + "static/media/IMG_20191128_112118.5eabd083.jpg";